import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import WebAndMobileDevelopment from "../../components/Service/Development";
import AnimatedPage from "../../components/ui/AnimatePage";
import Container from "../../components/ui/Container";
import { useIntroContext } from "../../hooks/useIntroContext";

const WebPage: React.FC = () => {



  return (
    <>
       <Container>
        <WebAndMobileDevelopment />
      </Container>
    </>

  );
};

export default WebPage;
